import { IMarketCampaignChannel } from "../redux/marketCampaign/marketCampaign.types";
import { initialWhatsAppTemplateData } from "../redux/whatsappTemplate/defaultState";
import {
  IWhatsAppTemplate,
  IWhatsAppTemplateData,
} from "../redux/whatsappTemplate/whatsappTemplate.types";

export const convertToWhatsAppTemplateData = (
  templateData: IMarketCampaignChannel,
  channelData: IWhatsAppTemplateData,
): IWhatsAppTemplateData => {
  // Safely get header_media or default to empty array
  const headerMedia = Array.isArray(templateData?.header_media)
    ? templateData.header_media
    : [];

  if (channelData && templateData) {
    return {
      name: channelData.name,
      category: channelData.category,
      example: {
        header_text: [],
        body_text: [],
      },
      components: channelData.components,
      header: {
        type: "HEADER",
        format: headerMedia[0]?.type as "IMAGE" | "DOCUMENT" | "TEXT" | null,
        text: null,
        example: {
          header_text: [],
          header_handle:
            headerMedia.map((media) => ({
              url: media.value,
              path: media.value,
              file: null,
              key: media.value,
            })) || null,
        },
      },
      body: {
        type: "BODY",
        text: channelData?.body?.text,
        example: {
          body_text: channelData?.body?.example?.body_text,
        },
      },
      buttons: {
        type: "BUTTONS",
        buttons: channelData?.buttons?.buttons,
      },
      footer: {
        type: "FOOTER",
        text: channelData?.footer?.text,
      },
      status: channelData.status,
      company_outlet_uuid: channelData.company_outlet_uuid || "",
      attachment: headerMedia.map((media) => media.value) || [],
      meta_id: channelData.meta_id,
    };
  }

  // Fallback to minimal data if no API template
  return {
    ...initialWhatsAppTemplateData,
    name: templateData?.template_name || "",
    company_outlet_uuid: templateData?.company_outlet_uuid || "",
    attachment: headerMedia.map((media) => media.value) || [],
  };
};

// Convert IWhatsAppTemplateData to IMetaTemplate
export const convertToMetaTemplate = (
  template: IWhatsAppTemplateData,
): IWhatsAppTemplate => {
  return {
    company_outlet_uuid: template.company_outlet_uuid || "",
    company_outlet_name: "", // This might need to be fetched or passed as prop
    name: template.name,
    status:
      (template.status as "APPROVED" | "REJECTED" | "PENDING" | null) ||
      "PENDING",
    reason: template.rejected_reason || null,
    header: template.header?.text || null,
    components: template.components || [],
    body: template.body?.text || null,
    template_id: null,
    meta_id: null,
  };
};
